<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="col-9 beast-page-display">
          <h1 class="beast-page-title">{{page.title}}</h1>
          <vue-markdown class="beast-page-content" v-text="page.text" />
        </div>
        <div class="col-3 beast-page-sidebar">
          <div class="beast-page-widget" v-if="page.Children.length">
            <h4 class="beast-page-widget-header">Child Pages</h4>
            <ul class="beast-page-widget-content beast-child-listing">
              <li v-for="childPage in page.Children"
                  :key="childPage.slug"
                  class="beast-child-page">
                <router-link :to="`/dms/pages/${childPage.slug}`">
                  {{childPage.title}}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="beast-page-widget">
            <h4 class="beast-page-widget-header">Page Info:</h4>
            <ul class="beast-page-widget-content">
              <li v-if="page.Category.slug">
                <strong>Category:</strong>
                <router-link :to="`/dms/categories/${page.Category.slug}`">
                  {{page.Category.name}}
                </router-link>
              </li>
              <li v-if="page.Author && page.Author.username">
                <strong>Author:</strong>
                <router-link :to="`/profile/${page.Author.username}`">
                  {{page.Author.firstName}} {{page.Author.lastName}}
                </router-link>
              </li>
              <li v-if="page.Parent && page.Parent.slug">
                <strong>Parent:</strong>
                <router-link :to="`/dms/pages/${page.Parent.slug}`">
                  {{page.Parent.title}}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="beast-page-widget" v-if="page.RelatedPages.length">
            <h4 class="beast-page-widget-header">Related Pages</h4>
            <ul class="beast-page-widget-content">
              <li v-for="relatedPage in page.RelatedPages"
                  :key="relatedPage.slug"
                  class="beast-related-page">
                <router-link :to="`/dms/pages/${relatedPage.slug}`">
                  {{relatedPage.title}}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<style scoped lang="scss">
  .beast-page-display {
    .beast-page-title {

    }

    .beast-page-content {

    }
  }

  .beast-page-sidebar {
    .beast-page-widget {
      margin-bottom: 25px;

      .beast-page-widget-header {
        padding-bottom: 8px;
        border-bottom: 1px solid #dcdcdc;
      }

      .beast-page-widget-content {
        list-style: none;
        padding: 2px 0;
        margin: 0;

        &.beast-child-listing {
          list-style: disc;
          padding: 2px 0 2px 22px;
        }

        li {
          margin-bottom: 5px;
          strong {
            display: block;
          }

          &.beast-child-page {
            margin-bottom: 8px;
            a {
              color: $beast-gray;
            }
          }
          &.beast-related-page {
            a {
              color: $beast-gray;
            }
          }
        }
      }
    }
  }
</style>

<script>
import VueMarkdown from "vue-markdown";

import BeastHeader from "../components/header/BeastHeader.vue";
import BeastFooter from "../components/footer/BeastFooter.vue";

export default {
  components: {
    BeastFooter,
    BeastHeader,
    VueMarkdown
  },
  props: {
    slug: {
      type: String,
    }
  },
  watch: {
    slug() {
      this._fetchData();
    }
  },
  data() {
    return {
      page: {
        title: "",
        slug: "",
        text: "",
        Children: [],
        RelatedPages: [],
        Category: {
          name: "",
          slug: ""
        },
        Author: {
          username: "",
          firstName: "",
          lastName: ""
        },
        Parent: {
          title: "",
          slug: ""
        },
      }
    };
  },
  methods: {
    async _fetchData() {
      const response = await this.axios.get(`/dms/page/${this.slug}`);
      this.page = response.data;
      this.setTitle(this.page.title);
    }
  },
  beforeMount() {
    this._fetchData();
  }
};
</script>
